import React, {useMemo} from "react";
import {Panel, Placeholder} from "rsuite";

const BasicStatBox = (props) => {
    const { content } = props;
    return useMemo(() => {
        return (
            <>
                <Panel {...props} bordered>
                    {content ?? <Placeholder.Paragraph /> }
                </Panel>
            </>
        );
    }, [content, props]);
}

export default BasicStatBox;